import clsx from "clsx"
import { FC } from "react"
import { useGame } from "@/providers/GameProvider"
import {
  ActiveEffects,
  Separator,
  UserInfo,
  UserRuneBalance,
  UserSpeedBonus
} from ".."
import styles from "./GameSideOpponent.module.scss"

export const GameSideOpponent: FC = () => {
  const { opponent, opponentInfo, opponentStatistics, opponentName } = useGame()

  return (
    <div className={clsx(styles.GameSideOpponent)}>
      <ActiveEffects playerId={opponent?.player} />
      <Separator styleType={1} />
      <UserSpeedBonus speedBonus={opponent?.speedBonus} />
      <Separator styleType={2} />
      <UserRuneBalance
        speed={{
          value: opponent?.speed,
          deltaValue: opponent?.deltaSpeed
        }}
        luck={{
          value: opponent?.luck,
          deltaValue: opponent?.deltaLuck
        }}
        stamina={{
          value: opponent?.stamina,
          deltaValue: opponent?.deltaStamina
        }}
      />
      <Separator styleType={1} />
      <UserInfo
        playerInfo={opponentInfo}
        playerStatistics={opponentStatistics}
        name={opponentName}
      />
      {/* {isDevMode && (
        <div className={styles.DebugPlayersStats}>
          <DebugPlayersStats playerState={opponent} />
        </div>
      )} */}
    </div>
  )
}
